import { InstallerStatusEnum } from '@bo-client/shared/models/installerPassDto';
import { StatusRuleSet } from '../status-availability.model';

/** Installateurausweis: Status, die kein Prozessschritt erreicht. */
export const INSTALLER_PASS_STATUS_RULES: StatusRuleSet = {
  blacklist: {
    [InstallerStatusEnum.RequestRenew]: null,
    [InstallerStatusEnum.ReadyToValidate]: null
  }
};
